import {createContext} from 'react';

const ApptsContext = createContext();

export default ApptsContext;
